import { ProgressStateContext } from 'ProgressContext'
import { useContext } from 'react'

export function useProgress() {
  return useContext(ProgressStateContext)
}
